<template>
  <div
    :class="classes"
    class="pt-2"
  >
    <base-avatar
      v-if="icon"
      v-animate-onscroll="clickable ? 'animated swing' : null"
      :color="getColorWhileHover"
      :dark="dark"
      :icon="icon"
      :outlined="outlined"
      :size="size"
      class="mb-3"
      @mouseover="hovered = true"
      @mouseout="hovered = false"
    />

    <div :class="horizontal && title && 'ml-6'">
      <base-title
        :title="title"
        class="text-uppercase"
        space="3"
      />

      <base-body
        v-if="text || $slots.default"
        :space="horizontal ? 0 : undefined"
        :text="text"
        class="mx-auto"
      >
        <slot />
      </base-body>
    </div>
  </div>
</template>

<script>
  import { documentToHtmlString } from '@contentful/rich-text-html-renderer'
  // Mixins
  import Heading from '@/mixins/heading'

  export default {
    name: 'BaseAvatarCard',

    mixins: [Heading],

    props: {
      align: {
        type: String,
        default: 'left',
      },
      color: String,
      hoverColor: String,
      dark: Boolean,
      horizontal: Boolean,
      icon: String,
      outlined: {
        type: Boolean,
        default: true,
      },
      space: {
        type: [Number, String],
        default: 8,
      },
      size: {
        type: [Number, String],
        default: 72,
      },
      text: Object,
      title: String,
      clickable: {
        type: [Boolean],
        default: false,
      },
    },
    data: () => ({
      hovered: false,
    }),
    computed: {
      classes () {
        const classes = [
          `mb-${this.space}`,
        ]

        if (this.horizontal) {
          classes.push('d-flex')

          if (!this.$slots.default && !this.text) {
            classes.push('align-center')
          }
        }

        return classes
      },
      getColorWhileHover () {
        return this.hovered ? this.hoverColor : this.color
      },
    },
    methods: {

      documentToHtmlString,
    },
  }
</script>
